import { useTaxDispatch, useTaxSelector } from "../../../../redux/general/reduxStore";
import React from "react";
import { addFeedback, removeFeedback } from "../../../../redux/feedbackSlice";
import { CoreUserFeedback } from "@mm-products/java-multima-framework";
import { useTranslation } from "react-i18next";
import target = CoreUserFeedback.target;

export default function useFeedbackRequests() {
    const dispatch = useTaxDispatch();
    const feedbacks = useTaxSelector((state) => state.feedback.feedbacks);
    const { t } = useTranslation();

    const onFeedbackDone = React.useCallback(
        (feedback: CoreUserFeedback) => {
            dispatch(removeFeedback(feedback));
        },
        [dispatch]
    );
    const createDirectUserFeedback = React.useCallback(
        () => dispatch(addFeedback({ target: target.WEB, description: t("feedback.manualFeedback").toString() })),
        [dispatch, t]
    );

    return {
        createDirectUserFeedback,
        feedbacks,
        onFeedbackDone,
    };
}
